// src/components/Hero/Hero.jsx
import React from 'react';
import './Hero.scss';

function Hero() {
  return (
    <section className="hero">
      <div className="hero__overlay">
        <div className="hero__content">
          <h1>Собери свой ПК мечты</h1>
          <p>ilhompc — магазин, где всё под контролем: от винтика до RTX.</p>
        </div>
      </div>
    </section>
  );
}

export default Hero;
